import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _styled from "@emotion/styled/base";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import SegmentLogo from '@segment/matcha/components/SegmentLogo';
import Button from '@segment/matcha/components/Button';
import ButtonText from '@segment/matcha/components/ButtonText';
import DesktopNavBase, * as DesktopNav from '@segment/matcha/recipes/Navigation/DesktopNavigation';
import * as Navbar from '@segment/matcha/recipes/Navigation/DesktopNavigation/Navbar';
import useNavigation from '@segment/matcha/recipes/Navigation/useNavigation';
import { trackButtonClick } from '@segment/tracking/scripts';
import { usePageConfig } from '@segment/contexts/page';
import utilityData from '../data/utility';
import Products from './Dropdowns/Products';
import Docs from './Dropdowns/Docs';
import Resources from './Dropdowns/Resources';
import Solutions from './Dropdowns/Solutions';
import SupportMenu from './SupportMenu';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

var DesktopNavigation = function DesktopNavigation(_ref) {
  var announcement = _ref.announcement;
  var pageConfig = usePageConfig();

  var _useNavigation = useNavigation(),
      getDropdownLinkProps = _useNavigation.getDropdownLinkProps;

  var _utilityData = utilityData(pageConfig),
      demoButton = _utilityData.demoButton,
      loginButton = _utilityData.loginButton,
      links = _utilityData.links,
      signUpButton = _utilityData.signUpButton;

  return _jsxs(DesktopNavBase, {
    children: [_jsxs(DesktopNav.UtilityNav, {
      announcement: announcement,
      children: [links.map(function (el) {
        return _jsx(SupportMenu, {
          links: el
        }, el.title);
      }), _jsx(ButtonTextSmall, {
        size: "small",
        variant: "mono",
        href: loginButton.url,
        children: loginButton.text
      })]
    }), _jsxs(DesktopNav.Navbar, {
      children: [_jsx(Navbar.Brand, {
        href: "/",
        onClick: function onClick() {
          return trackButtonClick({
            buttonText: "Segment Logo",
            targetUrl: "/",
            buttonCampaign: "nav"
          });
        },
        children: _jsx(SegmentLogo, {
          alt: "Twilio, Inc."
        })
      }), _jsxs(Navbar.Content, {
        role: "menubar",
        children: [_jsx("li", {
          role: "none",
          children: _jsx(Navbar.Link, _objectSpread(_objectSpread({
            role: "menuitem",
            title: "Products"
          }, getDropdownLinkProps("products")), {}, {
            children: _jsx(Products, {})
          }))
        }), _jsx("li", {
          role: "none",
          children: _jsx(Navbar.Link, _objectSpread(_objectSpread({
            role: "menuitem",
            title: "Solutions"
          }, getDropdownLinkProps("solutions")), {}, {
            children: _jsx(Solutions, {})
          }))
        }), _jsx("li", {
          role: "none",
          children: _jsx(Navbar.Link, {
            role: "menuitem",
            title: "Pricing",
            href: "/pricing/",
            onClick: function onClick() {
              return trackButtonClick({
                buttonText: "Pricing",
                targetUrl: "/pricing/",
                buttonCampaign: "nav"
              });
            }
          })
        }), _jsx("li", {
          role: "none",
          children: _jsx(Navbar.Link, _objectSpread(_objectSpread({
            role: "menuitem",
            title: "Docs"
          }, getDropdownLinkProps("docs")), {}, {
            children: _jsx(Docs, {})
          }))
        }), _jsx("li", {
          role: "none",
          children: _jsx(Navbar.Link, _objectSpread(_objectSpread({
            role: "menuitem",
            title: "Resources"
          }, getDropdownLinkProps("resources")), {}, {
            children: _jsx(Resources, {})
          }))
        })]
      }), _jsxs(Navbar.Aside, {
        children: [_jsx(ButtonText, {
          href: signUpButton.url,
          size: "small",
          variant: "mono",
          onClick: function onClick() {
            return trackButtonClick({
              buttonText: signUpButton.text,
              targetUrl: signUpButton.url,
              buttonCampaign: "nav"
            });
          },
          children: signUpButton.text
        }), _jsx(Button, {
          size: "medium",
          color: "primary",
          variant: "filled",
          href: demoButton.url,
          onClick: function onClick() {
            return trackButtonClick({
              buttonText: demoButton.text,
              targetUrl: demoButton.url,
              buttonCampaign: "nav"
            });
          },
          children: demoButton.text
        })]
      })]
    })]
  });
};

export default DesktopNavigation;

var ButtonTextSmall = /*#__PURE__*/_styled(ButtonText, true ? {
  target: "e1uv8xvu0"
} : {
  target: "e1uv8xvu0",
  label: "ButtonTextSmall"
})("font-size:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.buttonSmall;
}, ";" + (true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));